import { Feature } from "ol";
import { Extent } from "ol/extent";
import { Geometry } from "ol/geom";

export type VtxParseType = "lines" | "objects" | "labels";

export enum TokenType {
    LINE,
    FEATURE,
    ATTRIBUTE,
    TEXT,
    OTHER,
    EOF
}

export default abstract class ParserBase {
    protected _lines: string[];
    protected _cursor = 0;
    protected _textScale = 1;
    protected _offset = {x:0, y:0};
    protected _extent:Extent;

    constructor(src: string) {
        this._lines = src.split("\n");
        this.parseHeader();
    }

    getCurrentTokenType():TokenType {
        if (this._cursor > this._lines.length)
            return TokenType.EOF;

        if (!this._lines[this._cursor] || this._lines[this._cursor].trim().length < 2) {
            return TokenType.OTHER;
        }
        switch (this._lines[this._cursor].trim().substr(0, 2)) {
            case "&O":
                return TokenType.FEATURE;
            case "&L":
                return TokenType.LINE;
            case "&A":
                return TokenType.ATTRIBUTE;
            case "&T":
                return TokenType.TEXT;
            default:
                return TokenType.OTHER;
        }
    }

    getExtent():Extent {
        return this._extent;
    }

    abstract parseFeature():Feature;
    abstract parseGeometry():Geometry;

    protected readLine():TokenType {
        this._cursor++;
        return this.getCurrentTokenType();
    }

    protected skipUntil(targetToken:TokenType):TokenType {
        let token = this.getCurrentTokenType();
        while(token !== targetToken && token !== TokenType.EOF)
            token = this.readLine();
        return token;
    }

    protected parseAttribute() {
        let attributeTokens = this._lines[this._cursor].replace("&A", "").trim().split("=");
        if (attributeTokens.length > 1) {
            return [attributeTokens[0], attributeTokens.slice(1).join()];
        } else {
            return [attributeTokens[0], undefined];
        }
    }

    private parseHeader() {
        if (this._lines){
            let redukcia = [0,0];
            let headerLine = this._lines.find(l => l.startsWith("&V"));
            if (headerLine) {
                let tokens = headerLine.split(" ");
                if (tokens.length == 6) {
                    redukcia[0] = +tokens[4];
                    redukcia[1] = +tokens[5];
                }
            }
            let dimensionsLine = this._lines.find(l => l.startsWith("&R"));
            if (dimensionsLine) {
                let tokens = dimensionsLine.split(" ");
                this._extent = [-tokens[3], -tokens[4], -tokens[1], -tokens[2]];
                if (tokens.length > 5) {
                    this._textScale = +tokens[5];
                    if (tokens.length > 6 && tokens[6] === "R") {
                        this._offset.x = redukcia[1];
                        this._offset.y = redukcia[0];
                    }
                }
            }
        }
    }
}
